import OlMap from 'ol/Map'
import { Extent } from 'ol/extent'
import { Geometry } from 'ol/geom'

import { getTrafficAreaFeatureMetadata } from '../../../../layers/trafficArea/trafficAreaFeatureMetadata'
import { findLayer } from '../../../../layers/utils/findLayer'
import { createNonBlockingRenderByTime } from '../../../../renderingQueue'

const nonblockingRender = createNonBlockingRenderByTime()

export async function selectTrafficAreaFeatureInExtent(
  map: OlMap,
  lassoPolygon: Geometry,
  lassoExtent: Extent,
) {
  const trafficAreaLayer = findLayer(map, 'trafficProfile')
  const trafficProfiles = new Set<string>()
  const selectedIds: string[] = []

  const featuresInExtent = trafficAreaLayer.getSource()?.getFeaturesInExtent(lassoExtent) ?? []

  nonblockingRender.reset()

  for (const feature of featuresInExtent) {
    await nonblockingRender.next()

    const mode = getTrafficAreaFeatureMetadata(feature, 'mode')
    if (mode === 'off') continue

    const recordId = feature.getId() as string

    if (recordId) {
      const extent = feature.getGeometry()?.getExtent()

      if (extent && lassoPolygon.intersectsExtent(extent)) {
        trafficProfiles.add(recordId.split('-')[0]) // Assuming the ID format is 'profile-id-suffix'
        selectedIds.push(recordId)
      }
    }
  }

  return { trafficProfiles: Array.from(trafficProfiles), trafficAreas: selectedIds }
}
